import React from 'react';
import cx from 'classnames';
import s from './VerifiedMembersQuota.module.scss';
import fonts from '../../styles/typography.module.scss';
import { InfoIcon } from '../../icons';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useSelector } from 'store/hooks';
import { RootState } from '../../store';
import { useParams } from 'react-router-dom';
import useCommunityCredits from '../../hooks/useCommunityCredits';

const VerifiedMembersQuota = () => {
  const platform = useSelector(
    (state: RootState) => state.user.platform || 'discord',
  );
  const platformPrefix = platform === 'discord' ? 'DIS' : 'TEL';
  const { communityId: activeCommunityId } = useParams() as {
    communityId: string;
  };
  const { credits: communityCredits } = useCommunityCredits(
    platformPrefix,
    activeCommunityId,
  );

  if (communityCredits?.currentVerifiedMembers === -1) {
    return null;
  }
  const totalTGRsCreated = communityCredits?.totalTGRsCreated ?? 0;
  const allowedVerified = communityCredits?.allowedVerifiedMembers ?? 0;
  const currentVerified = communityCredits?.currentVerifiedMembers ?? 0;
  const remainingVerified = communityCredits?.remainingVerifiedMembers ?? 0;

  return (
    <div>
      <div className={cx(s.wrapper)}>
        <div className={cx(s.row1, fonts.caption1)}>
          <p className={s.label} style={{ display: 'flex', gap: 2 }}>
            Total TGRs Created:{' '}
            <span
              data-tooltip-content={'Includes Role Composition'}
              data-tooltip-id="tooltip-verified"
            >
              <InfoIcon className={s.infoIcon} title="Info icon" />
            </span>
            <ReactTooltip id="tooltip-verified" place="right" variant="dark" />
          </p>
          <p>{totalTGRsCreated}</p>
        </div>

        <div className={cx(s.row, fonts.caption1)}>
          <p className={s.label}>Allowed Verified Members:</p>
          <p>{allowedVerified}</p>
        </div>

        <div className={cx(s.row, fonts.caption1)}>
          <p className={s.label}>
            Current Verified Members:{' '}
            <span
              data-tooltip-content={
                'Verified Members are the number of token gated role holders in your group'
              }
              data-tooltip-id="tooltip-verified"
            >
              <InfoIcon className={s.infoIcon} title="Info icon" />
            </span>
            <ReactTooltip id="tooltip-verified" place="right" variant="dark" />
          </p>
          <p>{currentVerified}</p>
        </div>

        <div className={cx(s.row, fonts.caption1)}>
          <p className={s.label}>Remaining Verified Members:</p>
          <p>{remainingVerified}</p>
        </div>
      </div>
    </div>
  );
};

export default VerifiedMembersQuota;
